import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MiddleColumnGrid from '@/views/patientMain/middleColumn/middleColumnGrid.vue';
import ResultSuggestionsUpper from '@/views/patientMain/middleColumn/resultSuggestions/resultSuggestionsUpper.vue';
import ResultSuggestionsLower from '@/views/patientMain/middleColumn/resultSuggestions/resultSuggestionsLower.vue';
import ResultSuggestionsTags from '@/views/patientMain/middleColumn/resultSuggestions/resultSuggestionsTags.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'resultSuggestions',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MiddleColumnGrid, null, {
    row1: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "mtop-15" }, null, -1)
    ])),
    row2: _withCtx(() => [
      _createVNode(ResultSuggestionsTags)
    ]),
    row3: _withCtx(() => [
      _createVNode(ResultSuggestionsUpper)
    ]),
    row4: _withCtx(() => [
      _createVNode(ResultSuggestionsLower)
    ]),
    _: 1
  }))
}
}

})